<p-multiSelect
    appendTo="body"
    placeholder="Select Events"
    [options]="(eventSuggestions$ | async)"
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    dataKey="id"
    (ngModelChange)="handleSelect($event)"
    [autofocusFilter]="!responsiveHelper.isSmallScreen"
    optionDisabled="disabled"
    optionValue="id"
    [disabled]="disabled"
    [class.ng-invalid]="ngControl?.invalid"
    [class.ng-touched]="ngControl?.touched"
>
    <ng-template
        let-suggestion
        pTemplate="item"
    >
        <div>
            <span>{{suggestion.event.title}} ({{suggestion.event.status | titlecase}})</span>
            <p-tag
                *ngIf="suggestion.invoiceStatus === 'finalized'"
                class="p-ml-2"
                value="Invoiced"
                severity="success"
            ></p-tag>
            <p-tag
                *ngIf="suggestion.invoiceStatus === 'draft'"
                class="p-ml-2"
                value="Invoice drafted"
            ></p-tag>
            <br>
            <small *ngIf="suggestion.event?.start">{{(suggestion.event.start * 1000) | date}}</small>
            <small *ngIf="!suggestion.event?.start">Unscheduled</small>
        </div>
    </ng-template>
</p-multiSelect>
